import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, DateInput, SelectArrayInput, SelectInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import Days from '../../StaticData/Days';
import Hours from '../../StaticData/Hours';
import Minutes from '../../StaticData/Minutes';

const styles = createStyles({
  days: {
    minWidth: 100
  },
  dropdown: {
    minWidth: 230
  }
});

// Note DateInput does NOT work in Safari.

type Props = {
  classes: any
};

const Flight = (props: Props) => (
  <div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Field
          component={DateInput}
          label="Start Date"
          name="flight_attributes.start_date"
          source="flight_attributes.start_date" /><br />

        <Field
          choices={Hours}
          component={SelectInput}
          label="Start Hour"
          name="flight_attributes.start_time_hour"
          source="flight_attributes.start_time_hour"
          translateChoice={false} />
        <span style={{ paddingLeft: 10 }}>
          <Field
            choices={Minutes}
            component={SelectInput}
            label="Start Min"
            name="flight_attributes.start_time_min"
            source="flight_attributes.start_time_min" />
        </span><br /><br />

        <Field
          component={BooleanInput}
          label="Server Time"
          name="flight_attributes.server_time"
          source="flight_attributes.server_time"
          style={{ width: '140px' }} /><br />
        <div style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.298039)' }}>Flight times are in UTC.</div><br />
      </div>
      <div style={{ flex: 1 }}>
        <Field
          component={DateInput}
          label="End Date"
          name="flight_attributes.end_date"
          source="flight_attributes.end_date" /><br />

        <Field
          choices={Hours}
          component={SelectInput}
          label="End Hour"
          name="flight_attributes.end_time_hour"
          source="flight_attributes.end_time_hour"
          translateChoice={false} />
        <span style={{ paddingLeft: 10 }}>
          <Field
            choices={Minutes}
            component={SelectInput}
            label="End Min"
            name="flight_attributes.end_time_min"
            source="flight_attributes.end_time_min" />
        </span><br />

        <Field
          allowEmpty
          choices={Days}
          className={props.classes.days}
          component={SelectArrayInput}
          label="Days"
          name="flight_attributes.days"
          source="flight_attributes.days" />
      </div><br />
    </div>
  </div>
);

export default withStyles(styles)(Flight);



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Flight.tsx